import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";
import { adminApiService } from "services/api";

const WarrantyPolicy = () => {
  const [content, setContent] = useState("");

  const handleEditorChange = (content, editor) => {
    setContent(content);
  };

  const saveContent = async () => {
    try {
      const response = await adminApiService.updateWarrantyPolicy(content);

      if (!response.ok) {
        throw new Error("Failed to save content");
      }

      const result = await response.json();
      console.log("Content saved successfully:", result);
      toast.success("Warranty Policy updated successfully!");
    } catch (error) {
      console.error("Error saving content:", error);
      toast.error("Failed to save content. Please try again.");
    }
  };

  const getWarrantyPolicyContent = async () => {
    try {
      const response = await adminApiService.getWarrantyPolicy();

      if (!response.ok) {
        throw new Error("Failed to get content");
      }
      const result = await response.json();

      setContent(result.data?.content  || "");
    } catch (error) {
      console.error("Error getting content:", error);
      toast.error("Failed to get content. Please try again.");
    }
  };

  useEffect(() => {
    getWarrantyPolicyContent();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-10 rounded-2xl bg-white p-8 shadow-sm">
          <div className="flex flex-col items-center justify-between space-y-4 sm:flex-row sm:space-y-0">
            <div>
              <h1 className="text-4xl font-bold text-gray-900">
                Warranty Policy
              </h1>
              <p className="mt-3 text-base text-gray-700">
                Manage your website's warranty policy content
              </p>
            </div>
          </div>
        </div>

        {/* Editor Section */}
        <div className="rounded-2xl bg-white p-8 shadow-sm">
          <Editor
            apiKey={process.env.REACT_APP_TINY_MCE_EDITOR_API_KEY}
            value={content}
            init={{
              height: 1000,
              menubar: true,
              plugins: [
                "advlist",
                "autolink",
                "lists",
                "link",
                "image",
                "charmap",
                "print",
                "preview",
                "anchor",
                "searchreplace",
                "visualblocks",
                "code",
                "fullscreen",
                "insertdatetime",
                "media",
                "table",
                "paste",
                "help",
                "wordcount",
                "imagetools",
                "emoticons",
                "template",
                "directionality",
                "textcolor",
                "colorpicker",
                "autosave",
                "codesample",
                "textpattern",
                "mediaembed",
                "toc",
                "autoresize",
                "charcount",
                "codesample",
                "quickbars",
                "emoji",
                "autosave",
                "dragdrop",
                "filemanager",
                "codebeamer",
                "contextmenu",
                "imagegallery",
                "spellchecker",
                "mention",
                "wordcount",
                "importcss",
                "print",
                "fullscreen",
                "pagebreak",
                "directionality",
                "visualchars",
              ],
              toolbar:
                "undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | fontselect fontsizeselect | forecolor backcolor | bullist numlist outdent indent | link image media table | blockquote code | insertdatetime emoticons charmap | fullscreen preview | removeformat | help | searchreplace visualblocks | insertfile | pagebreak | insertdate inserttime | ltr rtl | copy paste cut",
              menubar: "file edit view insert format tools table help",
              quickbars_selection_toolbar:
                "bold italic | quicklink h2 h3 blockquote quickimage",
              contextmenu:
                "cut copy paste | link image | inserttable | cell row column",
              image_advtab: true,
              file_picker_types: "image,media",
              toolbar_sticky: true,
              image_caption: true,
              statusbar: true,
              branding: false,
              toolbar_mode: "sliding",
            }}
            onEditorChange={handleEditorChange}
          />

          <div className="mt-10 flex w-full justify-end">
            <button
              onClick={saveContent}
              className="rounded-xl bg-primary px-6 py-3 text-base font-medium text-white shadow-sm transition-all hover:bg-primaryDark hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarrantyPolicy;
